import styled from 'styled-components'
import Switch from '@mui/material/Switch';
export const StyledSwitch = styled(Switch)``;